// extracted by mini-css-extract-plugin
export default {"joke-list":"JokeList_joke-list__lLUnQ"};